import React, { Component, Fragment } from "react";
import {
  StyledMarketplaceHeader,
  StyledMarkerplaceCollection,
  StyledMarketPlaceGallery,
  StyledMarkerplaceCard,
  StyledMarketplaceContent,
  StyledTemplatesContainer,
} from "../_components/styled/home/stylesHome";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import { StyledMarketPlaceSwiperButton } from "../_components/styled/details/stylesDetails";
import { batch, connect } from "react-redux";
import DesignCard from "../_components/home/DesignCard";
import { TAB_TEMPLATES } from "../_components/details/constants";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import { withRouter } from "react-router-dom";
import Format from "string-format";
import {
  SEARCH_TEMPLATES_SCREEN,
  TEMPLATES_BY_FORMAT_SCREEN,
} from "../_utils/routes";
import axios from "axios";
import {
  fetchTemplatesByGroup,
  resetStories,
} from "../_actions/storiesActions";
import TldrAiBase from "../TldrAi/TldrAiBase";
import TldrSearch from "../_components/common/TldrSearch";
import TemplateFormatsSwiper from "./TemplateFormatsSwiper";
import TldrSearchSuggestion from "../_components/common/TldrSearchSuggestion";
import {
  MAIN_CONTAINER_SCROLLABLE_TARGET_ID,
  TEMPLATES_KEY,
} from "../_utils/constants";
import TLDRTitleSearch from "../_components/common/TLDRTitleSearch";
import { closeSidebar } from "../_actions/sidebarSliderActions";
import {
  FaArrowLeft,
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaSearch,
} from "react-icons/fa";
import { Box, Icon, Image, Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import TldrMobileSearchSuggestion from "../_components/common/TldrMobileSearchSuggestion";

class ViewAllFormatTemplates extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);

    const {
      params: { format },
    } = this.props.match;

    this.state = {
      searchTerm: "",
      showSuggestions: false,
      requestedFormat: format,
      showMobileSuggestions: false,
    };
  }

  componentDidMount() {
    batch(() => {
      this.props.resetStories();
      this.props.closeSidebar();
      this.props.fetchTemplatesByGroup(
        "",
        this.props,
        this.signal.token,
        1,
        this.state.requestedFormat === "videos" ? 1 : 0
      );
    });
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  getHeadings = () => {
    const { t } = this.props;
    return (
      <>
        <Text fontSize={"1.25rem"} fontWeight={"bold"}>
          {t("story.what_to_create")}
        </Text>
        <Text fontSize={"0.875rem"} color={"gray.300"}>
          {t("story.get_started_template")}
        </Text>
      </>
    );
  };

  handleSearch = (keyword) => {
    this.setState({
      searchTerm: keyword,
      showSuggestions: true,
    });
  };

  loadMoreData = () => {
    const { searchTerm } = this.state;
    this.props.fetchTemplatesByGroup(
      searchTerm,
      this.props,
      this.signal.token,
      this.props.stories.page,
      this.state.requestedFormat === "videos" ? 1 : 0
    );
  };

  goViewAll = (templateType) => {
    const { searchTerm } = this.state;
    const url = Format(TEMPLATES_BY_FORMAT_SCREEN, templateType?.group_key);

    this.props.history.push({
      pathname: encodeURI(url),
      search: searchTerm?.length > 0 ? `?search=${searchTerm}` : "",
    });
    // this.props.history.go(0);
  };

  handleShowAllSearchTemplates = (keyword) => {
    this.setState(
      {
        searchTerm: keyword,
        showSuggestions: false,
      },
      () => {
        const { searchTerm } = this.state;
        this.props.history.push({
          pathname: SEARCH_TEMPLATES_SCREEN,
          search: searchTerm.length > 0 ? `?search=${searchTerm}` : "",
        });
      }
    );
  };

  handleSearchWrapperOnBlur = (event) => {
    if (event.currentTarget.id !== event.relatedTarget?.id) {
      this.setState({ showSuggestions: false });
    }
  };

  handleBackArrowClick = () => {
    if (this.state.isSearchOpen) {
      this.toggleSearchVisibility();
    } else {
      this.handleSearchEscKeyEvent();
    }
  };

  render() {
    const headings = this.getHeadings();
    const { stories, t, isMobileView } = this.props;
    const { loaded, payload } = stories;
    const {
      searchTerm,
      showSuggestions,
      requestedFormat,
      showMobileSuggestions,
    } = this.state;

    let cards = [];
    var templateTypesContent =
      payload &&
      payload.map((templateType, index) => {
        if (!templateType.payload) {
          return <Fragment key={index}></Fragment>;
        }

        cards = templateType.payload.map((template) => {
          const { id, image_height, image_width } = template;
          return (
            <StyledMarkerplaceCard
              key={id}
              location="template-marketplace"
              height={image_height}
              width={image_width}
            >
              <DesignCard
                key={id}
                story={template}
                tab={TAB_TEMPLATES}
                showHoverOverlay={true}
                isUsedInSwiper={true}
              />
            </StyledMarkerplaceCard>
          );
        });

        let aspectRatio =
          templateType?.payload[0]?.image_width /
          templateType?.payload[0]?.image_height;
        const numberOfTiles = 6; // It can be changeable.
        let slidesPerView =
          aspectRatio >= 6
            ? 4.5
            : aspectRatio >= 2
            ? 3.5
            : aspectRatio === 1
            ? 5.5
            : aspectRatio >= 1
            ? numberOfTiles / aspectRatio
            : aspectRatio < 0.3
            ? 12
            : aspectRatio < 0.9 && aspectRatio > 0.8
            ? 8
            : numberOfTiles * (aspectRatio + 0.4);

        return (
          <div
            key={index}
            style={{ marginBottom: isMobileView ? "25px" : "40px" }}
          >
            <StyledMarketplaceHeader key={`${index}_header`}>
              <div className="header">{templateType?.format?.display_name}</div>
              <div
                className="view-all"
                onClick={() => this.goViewAll(templateType)}
              >
                {t("view_all")}
                <Icon as={FaArrowRight} ml={2} />
              </div>
            </StyledMarketplaceHeader>
            <StyledMarkerplaceCollection key={`${index}_collection`}>
              <TLDRSwiper
                swiperParams={{
                  ...marketPlaceCollectionSwiperParams,
                  slidesPerView: slidesPerView.toFixed(1),
                  breakpoints: {
                    1200: {
                      slidesPerView: slidesPerView.toFixed(1),
                    },
                    1024: {
                      slidesPerView: slidesPerView.toFixed(1),
                    },
                    768: {
                      slidesPerView: slidesPerView.toFixed(1),
                    },
                    640: {
                      slidesPerView:
                        aspectRatio > 5 ? 2.5 : aspectRatio > 1.5 ? 2.5 : 3.5,
                    },
                    480: {
                      slidesPerView:
                        aspectRatio > 5 ? 1.5 : aspectRatio > 1.5 ? 2.5 : 3.5,
                    },
                    320: {
                      slidesPerView:
                        aspectRatio > 5 ? 1.5 : aspectRatio > 1.5 ? 2.5 : 3.5,
                    },
                  },
                }}
              >
                {cards}
              </TLDRSwiper>
            </StyledMarkerplaceCollection>
          </div>
        );
      });

    return (
      <StyledMarketplaceContent>
        <StyledMarketPlaceGallery
          renderlocation="view-all-format-templates"
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <TldrAiBase
            className="templates-header-box templates"
            cardBodyClassName="card-body marketplace-templates-card-body"
          >
            <Box className="templates-info-container" p={5}>
              {headings}

              <div
                id="tldr-templates-search-wrapper"
                tabIndex={0}
                onBlur={(e) => this.handleSearchWrapperOnBlur(e)}
              >
                <TldrSearch
                  onSearch={this.handleSearch}
                  size="lg"
                  searchLocation="dashboard"
                  placeholder={t("search.search_template")}
                  width="400px"
                  onClear={this.handleSearchClear}
                  onFocus={this.handleSearchFocus}
                  handleEnterKeyEvent={this.handleShowAllSearchTemplates}
                  handleEscKeyEvent={() => {
                    this.setState({ showSuggestions: false });
                  }}
                />

                {showSuggestions && (
                  <TldrSearchSuggestion
                    width="400px"
                    searchTerm={searchTerm}
                    searchLocation="dashboard"
                    handleShowAllClick={this.handleShowAllSearchTemplates}
                    searchInFormats
                  />
                )}
              </div>
            </Box>

            <Image
              src="https://assets.simplified.co/images/templates-pic@2x.png"
              height="230"
              alt=""
            />
          </TldrAiBase>

          <TemplateFormatsSwiper
            requestedFormat={requestedFormat}
            searchTerm={searchTerm}
          />

          {/* mobile screen */}
          <StyledTemplatesContainer>
            {isMobileView ? (
              <Box>
                <TLDRTitleSearch
                  title={t("featured_templates.templates")}
                  searchConfig={{
                    onFocus: this.handleSearchFocusOnMobile,
                  }}
                  placeholder={t("search.search_template")}
                  addonLeftChildren={
                    <FaArrowLeft onClick={this.handleBackArrowClick} />
                  }
                ></TLDRTitleSearch>

                {showMobileSuggestions ? (
                  <TldrMobileSearchSuggestion
                    searchTerm={searchTerm}
                    handleShowAllClick={this.handleShowAllSearchTemplates}
                    placeholder={t("search.search_template")}
                    searchConfig={{
                      handleSearch: this.handleSearch,
                      onBlur: this.handleSearchBlurOnMobile,
                      handleEnterKeyEvent: this.handleShowAllSearchTemplates,
                      handleEscKeyEvent: this.handleSearchEscKeyEvent,
                      onClear: this.handleSearchClear,
                    }}
                    isOpen={showMobileSuggestions}
                    searchIn={TEMPLATES_KEY}
                  />
                ) : null}
              </Box>
            ) : null}

            {loaded && payload && !showMobileSuggestions ? (
              <div className="infinite-scroller-container">
                <TLDRInfiniteScroll
                  childrens={templateTypesContent}
                  hasMore={stories.loadMore}
                  loadMoreData={this.loadMoreData}
                  scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
                  className="all-format-template-gallery"
                />
              </div>
            ) : null}
          </StyledTemplatesContainer>
        </StyledMarketPlaceGallery>
      </StyledMarketplaceContent>
    );
  }

  handleSearchFocus = () => {
    this.setState({
      showSuggestions: true,
    });
  };

  handleSearchFocusOnMobile = () => {
    this.setState({
      showMobileSuggestions: true,
    });
  };

  handleSearchBlurOnMobile = () => {
    this.setState({
      showMobileSuggestions: false,
    });
  };

  handleSearchClear = (keyword) => {
    this.setState({
      searchTerm: keyword,
      showSuggestions: false,
    });
  };

  handleSearchEscKeyEvent = () => {
    this.setState({ showMobileSuggestions: false });
  };
}

let marketPlaceCollectionSwiperParams = {
  spaceBetween: 20, // padding between 2 elements (in px)
  slidesPerView: "auto",
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  mousewheel: false,
  lazy: true,
  preloadImages: false,
  containerClass: "marketplace-collection-swiper-container",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    disabledClass: "swiper-button-disabled",
  },
  renderPrevButton: () => (
    <StyledMarketPlaceSwiperButton
      className={"swiper-button-prev"}
      variance="left"
    >
      <div className="swiper-button-inner-div">
        <FaChevronLeft />
      </div>
    </StyledMarketPlaceSwiperButton>
  ),
  renderNextButton: () => (
    <StyledMarketPlaceSwiperButton
      className={"swiper-button-next"}
      variance="right"
    >
      <div className="swiper-button-inner-div">
        <FaChevronRight />
      </div>
    </StyledMarketPlaceSwiperButton>
  ),
};

ViewAllFormatTemplates.propTypes = {};

const mapStateToProps = (state) => ({
  stories: state.stories,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = {
  fetchTemplatesByGroup,
  resetStories,
  closeSidebar,
};

export default withTranslation(["common"])(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(ViewAllFormatTemplates))
);
